import { Fragment } from 'react';
import { bool, string, func } from 'prop-types';

import { ENV_VARS } from 'ENV_CONFIG';
import { Message } from 'jl-design-system/components/message/Message';
import {
  AppointmentInformation as CommonAppointmentInformation,
  DynamicAppointmentInformation,
} from './components';

import styles from './BookingInformation.scss';

export const TermAndConditions = ({ listItem = false }) => {
  const content = (
    <Fragment>
      To find out more about your appointment, please check the&nbsp;
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={`${ENV_VARS.REACT_APP_BROWSE_HOST}/customer-services/shopping-with-us/terms-and-conditions/ocab-terms-conditions`}
      >
        terms &amp; conditions
      </a>
      &nbsp;for this service
    </Fragment>
  );
  return listItem ? <li>{content}</li> : <span>{content}.</span>;
};

export const BookingInformation = ({
  appointmentInformation: AppointmentInformation,
  gender = null,
  bookingText = null,
}) => {
  const AppointmentInformationComponent = AppointmentInformation || CommonAppointmentInformation;
  return (
    <>
      <Message
        body={
          bookingText ? (
            <DynamicAppointmentInformation bookingText={bookingText}>
              <TermAndConditions />
            </DynamicAppointmentInformation>
          ) : (
            <AppointmentInformationComponent
              gender={gender}
              listItem={<TermAndConditions listItem />}
            />
          )
        }
        className={styles.AppointmentInformation__holder}
        title="Useful information"
        type="information"
      />
    </>
  );
};

TermAndConditions.propTypes = {
  listItem: bool,
};

BookingInformation.propTypes = {
  gender: string,
  bookingText: string,
  appointmentInformation: func,
};
